import { useStaticQuery, graphql } from 'gatsby'

export function useDataAwardsByEn() {
    const data = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageAbout(title: { eq: "Title awards" }, locale: { eq: "en" }) {
                value
            }

            items: allDatoCmsRenshinAward(sort: { fields: [sorting], order: ASC }, filter: { locale: { eq: "en" } }) {
                nodes {
                    year
                    title
                    text
                    certificateImage {
                        url
                        width
                        height
                    }
                }
            }
        }
    `)

    return data
}
